import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllProducts } from "../../redux/features/product/productSlice";
import { searchProduct } from "../../redux/features/search/searchSlice";

const Search = () => {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const dispatch = useDispatch();

  // useEffect(() => {

  // }, [search]);

  const formSubmitHandler = (e) => {
    e.preventDefault();

    if (search !== "") {
      navigate(`/products`);
    }
    dispatch(searchProduct(search));

    //   dispatch(
    //     getAllProducts({ sort: "", filterCategory: "", currentPage: "", search })
    //   );
    //   navigate(`products/${search}`);
  };
  return (
    <form
      onSubmit={formSubmitHandler}
      className="search flex md:flex-[0_0_40%] items-center justify-center"
    >
      <input
        type="text"
        className="search-input peer rounded-[100px] py-[.2rem] md:py-[.4rem] px-[1rem] md:px-[1.2rem] bg-white border-none w-[90%] transition duration-[.2s] mr-[-2rem] focus:outline-none focus:w-[100%] focus:bg-greys-light-3 "
        placeholder="Search Web"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <button className="search-button peer-focus:bg-greys-light-3 border-none bg-greys-light-2 focus:outline-none active:translate-y-[2px]">
        <svg
          className="icon w-5 h-5 fill-grey-dark-3"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <title>magnifying-glass</title>
          <path d="M17.545 15.467l-3.779-3.779c0.57-0.935 0.898-2.035 0.898-3.21 0-3.417-2.961-6.377-6.378-6.377s-6.186 2.769-6.186 6.186c0 3.416 2.961 6.377 6.377 6.377 1.137 0 2.2-0.309 3.115-0.844l3.799 3.801c0.372 0.371 0.975 0.371 1.346 0l0.943-0.943c0.371-0.371 0.236-0.84-0.135-1.211zM4.004 8.287c0-2.366 1.917-4.283 4.282-4.283s4.474 2.107 4.474 4.474c0 2.365-1.918 4.283-4.283 4.283s-4.473-2.109-4.473-4.474z"></path>
        </svg>
      </button>
    </form>
  );
};

export default Search;
